import { Component } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { ConfigService } from './services';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
})
export class AppComponent {
    appIniciada: boolean = false;
    headerHeight: number = 80;
    footerHeight: number = 100;
    constructor(
        private primengConfig: PrimeNGConfig,
        private translateService: TranslateService,
        private configService: ConfigService
    ) {}

    async ngOnInit() {
        this.primengConfig.ripple = true;
        this.configService.load();
        await this.translate();
        this.headerHeight = this.configService.config.header.height;
        this.footerHeight = this.configService.config.footer.height;
        this.appIniciada = true;
    }

    private translate() {
        return new Promise((res, rej) => {
            this.translateService.use('es'); // seteas la app en español
            this.translateService.get('primeng').subscribe((lang) => {
                this.primengConfig.setTranslation(lang); // setear el primeng en español
                return res(null);
            });
        });
    }
}
